<template>
  <div class="layout-vertical-center">
    <transition name="el-fade-in" mode="out-in">
      <el-card
        style="width: 552px;"
        class="card-no-header">
        <el-form
          ref="refForm"
          :model="formData"
          label-position="top">
          <back-button :label="$t('breadcrumb.back')" @click="handleBack" />
          <div class="font-24 font-w-bold color-blue mb-8">{{ $t('register.verification_email') }}</div>
          <p class="mb-8" style="color:#7D7C7B">{{ $t('register.verification_sent') }}</p>
          <p class="font-w-bold mb-20">{{ formData.email }}</p>
          <p class="mb-20" style="color:#7D7C7B">{{ $t('register.message') }}</p>
          <p class="font-w-bold">{{ $t('register.no_verification_email') }}</p>
          <div>
            <recaptcha ref="refRecaptcha" @response="handleRecaptchaResponse" />
          </div>
          <el-button
            :disabled="disableVerification"
            :loading="loading"
            type="primary"
            class="btn-full-block mt-40"
            @click="handleSignup">
            {{ $t('register.resend') }}
          </el-button>
        </el-form>
      </el-card>
    </transition>
  </div>
</template>

<script setup>
import { verification } from '@/api/auth.js'
import { reactive, ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'
import BackButton from '@/components/BackButton'
import Recaptcha from '@/components/Recaptcha'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const loading = ref(false)
const refForm = ref(null)
const refRecaptcha = ref(null)
const formData = reactive({
  email: route.query.email,
  g_recaptcha_response: ''
})
const disableVerification = computed(() => {
  if (
    formData.email &&
    formData.g_recaptcha_response
  ) {
    return false
  } else {
    return true
  }
})
const handleRecaptchaResponse = (response, type) => {
  if (type === 'success') {
    formData.g_recaptcha_response = response
  } else {
    formData.g_recaptcha_response = null
  }
}
const handleSignup = () => {
  if (!refForm.value) return
  refForm.value.validate((valid) => {
    if (valid) {
      loading.value = true
      verification(formData).then((response) => {
        refRecaptcha.value.handleReset()
        loading.value = false
        ElMessage({
          type: 'success',
          message: t('verification.verified')
        })
      }).catch((error) => {
        loading.value = false
        ElMessage({
          type: 'error',
          message: t('verification.no_verified')
        })
        console.log(error)
      })
    } else {
      loading.value = false
      ElMessage({
        type: 'warning',
        message: t('warning.complete_the_data')
      })
      return false
    }
  })
}
const handleBack = () => {
  router.push({ path: '/signup' })
}
</script>
